import { Outlet } from 'react-router-dom';
import { DashboardAuthGuard } from '@xinosolutions/xs-auth-react/portal';
import AppLoader from '../GeneralComponents/AppLoader';

export default function LearnixDashboardAuthGuard() {
  return (
    <DashboardAuthGuard
      redirectTo="/"
      spinner={
        <AppLoader wrapperClassName="circular-progress circular-progress--viewport" />
      }
    >
      <Outlet />
    </DashboardAuthGuard>
  );
}
